const sec2timeValues = (timeInSeconds) => {
    let pad = function (num, size) { return ('000' + num).slice(size * -1); },
    time = parseFloat(timeInSeconds / 1000).toFixed(3),
    hours = Math.floor(time / 60 / 60),
    minutes = Math.floor(time / 60) % 60;

    return pad(hours, 2) + ':' + pad(minutes, 2);
}

export default sec2timeValues;